import React, { FC, memo, useCallback } from 'react';
import Button from '@components/Button';
import { useUIDuck } from '@hooks/useUIDuck';
import { SC } from 'src/styles/theme';
import { HandledComponentError } from '@components/ErrorHandling';
import { useDispatch } from 'react-redux';
import {isBrandAC, ModalVersion} from 'src/constants/main';
import { Pages } from 'src/types/pages';
import UIDuck from 'src/redux/commonDucks/ui.duck';
import useTranslations from '@hooks/useTranslations';
import { useUserDuck } from '@hooks/useUserDuck';
import { usePlausible, UserEvent } from '@hooks/usePlausible';

export const SaveToYourProjectTemplate: FC<SC & { page?: Pages; additionalClassName?: string }> = memo(
    ({ className, additionalClassName, page }) => {
        const { isLoading } = useUIDuck();
        const dispatch = useDispatch();
        const { isUserLoggedInAsDealer } = useUserDuck();
        const { plausibleUserEvent } = usePlausible();
        const { t } = useTranslations();

        const onClick = useCallback(async () => {
            const isBasketPage = [Pages.basketV2, Pages.basket].includes(page);
            plausibleUserEvent(isBasketPage ? UserEvent.SaveCarBasket : UserEvent.SaveCarSelector);
            dispatch(
                UIDuck.openModal({
                    data: {},
                    modalType:
                        isUserLoggedInAsDealer && isBasketPage
                            ? UIDuck.MODAL_TYPES.SHARE_CONFIGURATION_PERSONALIZE_OFFER
                            : UIDuck.MODAL_TYPES.SAVE_YOUR_PROJECT,
                    modalVersion: ModalVersion.v2,
                })
            );
        }, []);

        try {
            return (
                <div className={additionalClassName ? `${className} ${additionalClassName}` : className}>
                    <Button
                        secondary={!isBrandAC}
                        primary={isBrandAC}
                        withoutBackground={isBrandAC}
                        fullWidth={page !== Pages.basketV2}
                        onClick={onClick}
                        id="TESTING_SAVE_CAR_BOX"
                        disabled={isLoading}
                    >
                        {t('header.nav.save.offer')}
                    </Button>
                </div>
            );
        } catch (e: any) {
            return <HandledComponentError error={e} />;
        }
    }
);

SaveToYourProjectTemplate.displayName = 'SaveToYourProjectTemplate';
